export enum OpportunityActions {
  Apply = 'apply',
  SendMessage = 'sendMessage',
  Leave = 'leave',
  Approve = 'approve',
  Reject = 'reject',
  RejectCandidate = 'rejectCandidate',
  Launch = 'launch',
  Delete = 'delete',
  Cancel = 'cancel',
  GiveFeedback = 'giveFeedback',
  SetCandidateDetails = 'setCandidateDetails',
}
